function initSystemReports($el) {
	if (PJQ.app.module === PJQ.constants.modules.APP) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'reports'
				}
			])
		}).get().done(_.bind(function (reports) {
			PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template("PanteraReports", 'Master', {isOldModule: true}), $el, {}, function () {
				let $reportSelect = $('#sReport')
				counter = 1;
				_.each(reports, function (report) {
					if (report.isCustom) {
						$reportSelect.append($('<option>', {
							id: report.id,
							value: 'NEWCUSTOMREPORT',
							text: report.name,
							label: report.name
						}));
					}
					else {
						$reportSelect.append($('<option>', {
							value: report.id,
							text: report.name,
							label: report.name
						}));
					}

					counter++;

					if (counter === 17 && PJQ.app.session.get('portalId') === 252) {
						$reportSelect.append($('<option>', {
							value: 'subcontractor_diversity_status',
							text: '04 - Sub Diversity Status',
							label: '04 - Sub Diversity Status'
						}));
					}
				});
				//this report is only enabled for 1 customer right now
				if (PJQ.app.session.get('portalId') === 94) {
					$reportSelect.append($('<option>', {
						value: 'new_work_logs_time_card',
						text: 'Superintendent Time Card',
						label: 'Superintendent Time Card'
					}));
				}

				renderSystemReports();
			});
		}, this));
	}
	else {
		renderSystemReports();
	}
}

function renderSystemReports() {
	let $reportSelect = jQuery('#sReport');
	if (window.location.host.indexOf("panteratools.com") !== -1) {
		$reportSelect.append("<option label ='Custom Reports' value='PANTERAMARKETING'>Custom Reports</option>");
	}

	if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'reports')) {
		let abExportSort = PJQ.app.portal.customization.reports.addressBookExportSort,
			$abExportOpt = $reportSelect.find('option[value="ABExport"]');
		if (abExportSort != null) {
			$abExportOpt.insertAfter($reportSelect.find('option').eq(abExportSort));
		}

		let abExportName = PJQ.app.portal.customization.reports.addressBookExportName;
		if (_.size(abExportName) > 0) {
			$abExportOpt.attr('label', abExportName).text(abExportName);
		}
	}

	$reportSelect.find('option:nth-child(2)').attr('selected', true);
	jQuery("form").validate({
		debug: true, onsubmit: false, showErrors: function (errorMap, errorList) {
		}, rules: {dfrom: {required: true, datePT: true}, dto: {required: true, datePT: true}}
	});
	jQuery(".datepick").datepicker({
		numberOfMonths: 3,
		showButtonPanel: true,
		buttonImage: "/i/calendar.png",
		buttonImageOnly: true
	});
	jQuery.validator.addMethod("datePT", function (value, element) {
		var c = !1, d = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
		if (d.test(value)) {
			var e = value.split("/"), f = parseInt(e[0], 10), g = parseInt(e[1], 10), h = parseInt(e[2], 10),
				i = new Date(h, f - 1, g);
			i.getFullYear() == h && i.getMonth() == f - 1 && i.getDate() == g ? c = !0 : c = !1
		}
		else c = !1;
		return this.optional(element) || c;
	}, "Please enter a valid date.");

	reportChanged();
}

function rexp(fileType) {
	var lastReport = '';
	jQuery('#sReport option').filter(':selected').each(function (index) {
		lastReport = jQuery(this).val();
	});
	if (lastReport == '')
		return;
	else if (lastReport == 'NEWCUSTOMREPORT') {
		if (currentReport.ExtraParametersString != null) {
			BuildExportNew(currentReport, fileType, currentParamArray);
		}
		else {
			BuildExportNew(currentReport, fileType);
		}
	}
	else {
		var isFromOk = jQuery("form").validate().element('#dfrom');
		var isToOk = jQuery("form").validate().element('#dto');

		if (!isFromOk && requiresDates(lastReport))
			jQuery('#dfrom').css('background-color', 'red');
		else
			jQuery('#dfrom').css('background-color', '');

		if (!isToOk && requiresDates(lastReport))
			jQuery('#dto').css('background-color', 'red');
		else
			jQuery('#dto').css('background-color', '');

		if ((!isFromOk || !isToOk) && requiresDates(lastReport)) {
			return;
		}

		if (!requiresExtraParams(lastReport)) {
			BuildExport(lastReport, fileType);
		}
		else {
			BuildExportExtraParams(lastReport, fileType);
		}
	}
}

function BuildExport(whichReport, fileType) {
	ShowReportLoading();
	fixfooter(null, null);
	if (fileType == 'PDF')
		PanteraScript.PanteraScriptService.GenerateReportPDF(whichReport, jQuery('#dfrom').val(), jQuery('#dto').val(), PJQ.app.session.id, BuildExportc, onScriptError);
	else if (fileType == 'XLS')
		PanteraScript.PanteraScriptService.GenerateReportExcel(whichReport, jQuery('#dfrom').val(), jQuery('#dto').val(), PJQ.app.session.id, BuildExportc, onScriptError);
}

function BuildExportExtraParams(whichReport, fileType) {
	ShowReportLoading();
	fixfooter(null, null);
	var reportParams = {};
	var jsonString;
	switch (whichReport) {
		case 'LVPENDBID':
		case 'LVAWARDBID':
		case 'LVAJNOTES':
			if (whichReport == 'LVAJNOTES') {
				reportParams["from"] = "01/05/2015";
				reportParams["to"] = "01/05/2015";
			}
			else {
				reportParams["from"] = jQuery('#dfrom').val();
				reportParams["to"] = jQuery('#dto').val();
			}
			reportParams['PM'] = jQuery('#spm').val();
			break;
	}
	var jsonString = JSON.stringify(reportParams);
	if (fileType == 'PDF') {
		PanteraScript.PanteraScriptService.GenerateReportKeyedParamsPDF(PJQ.app.session.id, whichReport, jsonString, BuildExportc, onScriptError);
	}
	else if (fileType == 'XLS') {
		PanteraScript.PanteraScriptService.GenerateReportKeyedParamsExcel(PJQ.app.session.id, whichReport, jsonString, BuildExportc, onScriptError);
	}
}

function BuildExportc(response) {
	var rr = jQuery.parseJSON(response);
	jQuery('#rcontent').html('<h3><a href="' + rr.DownloadURL + '" target=\"_blank\" >Click here to download your Report</a></h3>');
	fixfooter(null, null);
}

function requiresDates(report) {
	if (report == 'STENBLGC' || report == 'STENBLGS' || report == 'STENAWARD' || report == 'STENBLEXC' || report == 'STENBLSBS' || report == 'STENBLGIRLS' || report == 'STENPLREQ' || report == 'STENPLQUO' || report == 'STENPLOPP' || report == 'GCStats' || report == 'GCStatsPM' || report == 'SubStats' || report == 'ABExport' || report == 'ABExportG' || report == 'TOOLCACT' || report == 'LVAJNOTES')
		return false;

	return true;
}

function requiresExtraParams(report) {
	if (report == 'LVPENDBID' | report == 'LVAWARDBID' | report == 'LVAJNOTES') {
		return true;
	}
	else {
		return false;
	}

}

function rrefresh() {
	var lastReport = '';
	jQuery('#sReport option').filter(':selected').each(function (index) {
		lastReport = jQuery(this).val();
	});
	if (lastReport == '') {
		return;
	}
	else if (lastReport == 'NEWCUSTOMREPORT') {
		if (currentReport.ExtraParametersString != null) {
			BuildReportNew(currentReport, currentParamArray);
		}
		else {
			BuildReportNew(currentReport);
		}
	}
	else {
		var isFromOk = jQuery("form").validate().element('#dfrom');
		var isToOk = jQuery("form").validate().element('#dto');

		if (!isFromOk && requiresDates(lastReport))
			jQuery('#dfrom').css('background-color', 'red');
		else
			jQuery('#dfrom').css('background-color', '');

		if (!isToOk && requiresDates(lastReport))
			jQuery('#dto').css('background-color', 'red');
		else
			jQuery('#dto').css('background-color', '');

		if (requiresDates(lastReport) && (!isFromOk || !isToOk)) {
			return;
		}
		else if (requiresExtraParams(lastReport)) {
			BuildReportExtraParams(lastReport);
		}
		else if (requiresDates(lastReport) && isFromOk || isToOk && !requiresExtraParams(lastReport)) {
			var lastReport = '';
			jQuery('#sReport option').filter(':selected').each(function (index) {
				lastReport = jQuery(this).val();
			});
			BuildReport(lastReport);
		}
	}
}

function BuildReport(whichReport) {
	ShowReportLoading();
	fixfooter(null, null);
	PanteraScript.PanteraScriptService.GenerateReportHTML(whichReport, jQuery('#dfrom').val(), jQuery('#dto').val(), PJQ.app.session.id, BuildReportc, onScriptError);
}

function ShowReportLoading() {
	let loaderContainer = $('<div>', {
		class: 'of-hidden mt-2 mb-2'
	});
	jQuery('#rcontent').html(loaderContainer);
	new PJQ.Loader(loaderContainer, {
		type: 'noOverlay',
		text: 'Processing Report',
		isPrepend: false,
		animation: {
			in: 'fadeIn'
		}
	});
}

function BuildReportExtraParams(whichReport) {
	ShowReportLoading();
	fixfooter(null, null);
	//ADD ITEMS TO ARRAY TO PASS TO SCRIPT SERVICE
	var reportParams = {};
	switch (whichReport) {
		case 'LVPENDBID':
		case 'LVAWARDBID':
		case 'LVAJNOTES':
			if (whichReport == 'LVAJNOTES') {
				reportParams["from"] = "01/05/2015";
				reportParams["to"] = "01/05/2015";
			}
			else {
				reportParams["to"] = jQuery('#dto').val();
				reportParams["from"] = jQuery('#dfrom').val();
			}
			reportParams["PM"] = jQuery('#spm').val();
			break;
	}
	var jsonString = JSON.stringify(reportParams);
	PanteraScript.PanteraScriptService.GenerateReportKeyedParamsHTML(PJQ.app.session.id, whichReport, jsonString, BuildReportc, onScriptError);
}

function BuildReportNew(report, paramArray) {
	ShowReportLoading();
	fixfooter(null, null);
	//ADD ITEMS TO ARRAY TO PASS TO SCRIPT SERVICE
	var reportParams = {};
	if (report.HasDateFilter) {
		reportParams["FromDate"] = jQuery('#dfrom').val();
		reportParams["ToDate"] = jQuery('#dto').val();
	}
	if (paramArray != null) {
		for (var p = 0; p < paramArray.length; p++) {
			reportParams[paramArray[p]] = jQuery('#param_' + paramArray[p]).val();
		}
	}

	new PJQ.ajax.Request({
		endpoint: "/report/GenerateReport",
		data: {
			reportId: report.ReportId,
			parameters: JSON.stringify(reportParams)
		}
	}).post().done(function (data) {
		RenderReport(data);
	}).fail(function () {
	});
}

function RenderReport(data) {
	var lastReport = '';
	jQuery('#sReport option').filter(':selected').each(function (index) {
		lastReport = jQuery(this).val();
	});

	if (data.isImage) {
		$('#rcontent').html($('<img>', {
			style: 'width: 100%',
			src: 'data:image/png;base64,' + data.reportData
		}));
	}
	else {
		$("#rcontent").html($(data.reportData));
	}

	jQuery('#rcontent div div table tbody tr td[width="100%"]').attr('width', '0px');
	if (jQuery('#rcontent').height() < jQuery(window).height() && lastReport != 'GCStats' && lastReport != 'SubStats' && lastReport != 'GCStatsPM') {
		jQuery('body').css('height', '100%');
		jQuery('#divBody').css('padding-bottom', jQuery('#divFooter').height());
		jQuery('#divFooter').css('position', 'absolute');
		jQuery('#divFooter').css('bottom', '0');
	}
	else {
		jQuery('body').css('height', 'auto');
		jQuery('#divBody').css('padding-bottom', '24px');
		jQuery('#divFooter').css('position', 'relative');
	}
}

function BuildExportNew(report, fileType, paramArray) {
	ShowReportLoading();
	fixfooter(null, null);
	var reportParams = {};
	if (report.HasDateFilter) {
		reportParams["FromDate"] = jQuery('#dfrom').val();
		reportParams["ToDate"] = jQuery('#dto').val();
	}
	if (paramArray != null) {
		for (var p = 0; p < paramArray.length; p++) {
			reportParams[paramArray[p]] = jQuery('#param_' + paramArray[p]).val();
		}
	}
	var jsonString = JSON.stringify(reportParams);

	PanteraScript.PanteraScriptService.GenerateExportNew(PJQ.app.session.id, 'global', fileType.toLowerCase(), report.ReportId, jsonString, BuildExportc, onScriptError);
}

function BuildReportc(response) {
	var rr = jQuery.parseJSON(response);
	jQuery.get(rr.DownloadURL, function (data) {
		var lastReport = '';
		jQuery('#sReport option').filter(':selected').each(function (index) {
			lastReport = jQuery(this).val();
		});
		jQuery('#rcontent').html(data);
		jQuery('#rcontent div div table tbody tr td[width="100%"]').attr('width', '0px');
		if (jQuery('#rcontent').height() < jQuery(window).height() && lastReport != 'GCStats' && lastReport != 'SubStats' && lastReport != 'GCStatsPM') {
			jQuery('body').css('height', '100%');
			jQuery('#divBody').css('padding-bottom', jQuery('#divFooter').height());
			jQuery('#divFooter').css('position', 'absolute');
			jQuery('#divFooter').css('bottom', '0');
		}
		else {
			jQuery('body').css('height', 'auto');
			jQuery('#divBody').css('padding-bottom', '24px');
			jQuery('#divFooter').css('position', 'relative');
		}
	});
}

function onScriptError(response) {
	//alert('AJAX Error: ' + response.get_message() + ' - Stack Trace: ' + response.get_stackTrace());
}

function reportChanged() {
	var lastReport = '';
	var lastReportId = '';
	jQuery('#sReport option').filter(':selected').each(function (index) {
		lastReport = jQuery(this).val();
		lastReportId = jQuery(this).attr('id');
	});
	if (lastReport == 'NEWCUSTOMREPORT') {
		ShowReportLoading();
		fixfooter(null, null);
		jQuery('#dfrom').val('');
		jQuery('#dto').val('');
		jQuery('#dto').attr('disabled', 'disabled');
		jQuery('#dfrom').attr('disabled', 'disabled');
		jQuery('.extraParams').remove();
		jQuery('#dfrom').css('background-color', '');
		jQuery('#dto').css('background-color', '');
		PanteraScript.PanteraScriptService.GetReportInfoGlobal(lastReportId, InitNewUI, onScriptError);
	}
	else if (lastReport === 'new_work_logs_time_card') {
		jQuery('#sReport').val('');
		new PJQ.views.dailyReports.DailyReportWeeklyExportModal({
			model: new PJQ.models.reporting.Report({
				id: 'weekly',
				name: 'Weekly',
				options: [
					{
						id: _.unique(),
						type: 'DATE_RANGE',
						name: 'Dates',
						isRequired: true,
						defaultValue: {
							from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -6),
							to: new Date()
						},
						value: {
							from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
							to: new Date()
						}
					}
				]
			}),
			onDownload: _.bind(function (options, callback) {
				new PJQ.ajax.Request({
					endpoint: '/dailyreports/worklogs/timecard',
					data: {
						options: options,
						isApi2: true
					}
				}).post().done(_.bind(function (response) {
					PJQ.files.downloadFile(response.url, {
						isEndpoint: false
					});
					callback();
				}, this)).fail(_.bind(function (xhr, err, result) {
					callback();
				}, this));
			}, this)
		})
	}
	else if (lastReport === 'subcontractor_diversity_status') {
		jQuery('#sReport').val('');
		new PJQ.views.reporting.SubcontractorDiversityStatusExportModal({
			model: new PJQ.models.reporting.Report({
				id: 'subcontractor_diversity_status',
				name: 'Subcontractor Diversity Status',
				options: [
					{
						id: _.unique(),
						type: 'STRING_ARRAY',
						name: 'States',
						isRequired: true,
						defaultValue: {
							states: []
						},
						value: {
							states: []
						}
					}
				]
			}),
			onDownload: _.bind(function (options, callback) {
				new PJQ.ajax.Request({
					endpoint: '/reports/subcontractor_diversity_status',
					data: {
						options: options,
						isApi2: true
					}
				}).post().done(_.bind(function (response) {
					PJQ.files.downloadFile(response.url, {
						isEndpoint: false
					});
					callback();
				}, this)).fail(_.bind(function (xhr, err, result) {
					callback();
				}, this));
			}, this)
		});
	}
	else if (lastReport === 'subcontractor_diversity_status') {
		jQuery('#sReport').val('');
		new PJQ.views.reporting.SubcontractorDiversityStatusExportModal({
			model: new PJQ.models.reporting.Report({
				id: 'subcontractor_diversity_status',
				name: 'Subcontractor Diversity Status',
				options: [
					{
						id: _.unique(),
						type: 'STRING_ARRAY',
						name: 'States',
						isRequired: true,
						defaultValue: {
							values: []
						},
						value: {
							values: []
						}
					}
				]
			}),
			onDownload: _.bind(function (options, callback) {
				new PJQ.ajax.Request({
					endpoint: '/reports/subcontractor_diversity_status',
					data: {
						options: options,
						isApi2: true
					}
				}).post().done(_.bind(function (response) {
					PJQ.files.downloadFile(response.url, {
						isEndpoint: false
					});
					callback();
				}, this)).fail(_.bind(function (xhr, err, result) {
					callback();
				}, this));
			}, this)
		});
	}
	else {
		InitUI(lastReport);
	}
}

function DomInsertParamInput(paramName, inputHTML, optionsArray) {
	jQuery('#extraParams').after('<td class="extraParams" id=' + paramName + '></td>');
	var newInputTdId = '#' + paramName;
	jQuery(newInputTdId).append(inputHTML);
	if (optionsArray != null && inputHTML.toLowerCase().indexOf('select') != -1) {
		jQuery('#param_' + paramName).append('<option value="">Select...</option>');
		for (var opt = 0; opt < optionsArray.length; opt++) {
			jQuery('#param_' + paramName).append('<option value="' + optionsArray[opt] + '">' + optionsArray[opt] + '</option>');
		}
	}
}

var currentReport;
var currentParamArray = [];

function InitNewUI(response) {
	currentReport = jQuery.parseJSON(response);
	if (currentReport.HasDateFilter) {
		jQuery('#dfrom').attr('disabled', false);
		jQuery('#dto').attr('disabled', false);

		var thisDateMathArr;
		var thisDateFrom;
		var thisDateTo;
		if (currentReport.FromDateDefault.indexOf('Math:') != -1) {
			thisDateMathArr = currentReport.FromDateDefault.replace('Math:', '').split('|');
			thisDateFrom = CalculateDate(thisDateMathArr);
		}
		else {
			thisDateFrom = currentReport.FromDateDefault
		}
		if (currentReport.ToDateDefault.indexOf('Math:') != -1) {
			thisDateMathArr = currentReport.ToDateDefault.replace('Math:', '').replace('(', '').split('|');
			thisDateTo = CalculateDate(thisDateMathArr);
		}
		else {
			thisDateTo = currentReport.ToDateDefault;
		}

		jQuery('#dfrom').val(thisDateFrom);
		jQuery('#dto').val(thisDateTo);
	}
	else {
		jQuery('#dfrom').attr('disabled', true);
		jQuery('#dto').attr('disabled', true);
	}
	if (currentReport.ExtraParametersString != null) {

		var extraParamArr = currentReport.ExtraParametersString.split("|||");
		for (var ep = 0; ep < extraParamArr.length; ep++) {
			var thisReportParam = extraParamArr[ep].split("||");
			var thisParamName = thisReportParam[0];
			var thisInputDisplayName = thisReportParam[1];
			var thisInputType = thisReportParam[2];
			var thisDefaultVal = thisReportParam[4];
			var thisInputHTML = "";
			if (thisInputType.toLowerCase() == 'text') {
				thisInputHTML = '<input type="text" id="param_' + thisParamName + '">';
			}
			else if (thisInputType.toLowerCase() == 'number') {
				thisInputHTML = '<input type="number" id="param_' + thisParamName + '">';
			}
			else if (thisInputType.toLowerCase() == 'select') {
				thisInputHTML = '<select id="param_' + thisParamName + '"></select>';
			}
			else if (thisInputType.toLowerCase() == 'date') {
				thisInputHTML = '<input type="text" class="datepick hasDatepicker" style="width: 140px;" id="param_' + thisParamName + '">';
			}
			thisInputHTML = '<span>' + thisInputDisplayName + ': </span>' + thisInputHTML;
			currentParamArray.push(thisParamName);
			if (thisInputType.toLowerCase() == 'select') {
				var thisOptions = thisReportParam[3];
				var thisOptionsArr = [];
				if (thisOptions.indexOf('ProjectCustomField:') != -1 || thisOptions.indexOf('CompanyCustomField:') != -1 || thisOptions.indexOf('ContactCustomField:') != -1 || thisOptions.indexOf('User:') != -1) {
					PanteraScript.PanteraScriptService.GetCustomFieldChoicesForReports(thisOptions, thisParamName, thisInputHTML, thisDefaultVal, GetCustomFieldChoicesc, onScriptError);
				}
				else if (thisOptions.indexOf('|') != -1) {
					thisOptionsArr = thisOptions.split('|');
					DomInsertParamInput(thisParamName, thisInputHTML, thisOptionsArr);
					if (thisDefaultVal != null && thisDefaultVal != 'NULL') {
						jQuery('#param_' + thisParamName).val(thisDefaultVal);
					}
					BuildReportNew(currentReport, currentParamArray);
				}
				else {
					thisOptionsArr.push(thisOptions);
					DomInsertParamInput(thisParamName, thisInputHTML, thisOptionsArr);
					if (thisDefaultVal != null && thisDefaultVal != 'NULL') {
						jQuery('#param_' + thisParamName).val(thisDefaultVal);
					}
					BuildReportNew(currentReport, currentParamArray);
				}
			}
		}
	}
	else {
		BuildReportNew(currentReport);
	}
}

function GetCustomFieldChoicesc(response) {
	var cfOptions = jQuery.parseJSON(response);
	DomInsertParamInput(cfOptions.ParamName, cfOptions.InputHTML, cfOptions.ChoiceList);
	if (cfOptions.DefaultValue != null && cfOptions.DefaultValue != 'NULL') {
		jQuery('#param_' + cfOptions.ParamName).val(cfOptions.DefaultValue);
	}
	BuildReportNew(currentReport, currentParamArray);
}

function CalculateDate(mathArr) {
	var dnow = new Date();
	var thisMonth = dnow.getMonth() + 1;
	var thisDay = dnow.getDate();
	var thisYear = dnow.getFullYear();
	var thisMonthMath = mathArr[0];
	var thisDayMath = mathArr[1];
	var thisYearMath = mathArr[2];
	var thisMonthIsStatic = thisMonthMath.toLowerCase().indexOf('s:') != -1 ? true : false;
	var thisDayIsStatic = thisDayMath.toLowerCase().indexOf('s:') != -1 ? true : false;
	var thisYearIsStatic = thisYearMath.toLowerCase().indexOf('s:') != -1 ? true : false;
	var thisMonth;
	var thisDay;
	var thisYear;
	if (thisMonthIsStatic) {
		thisMonth = thisMonthMath.replace('s:', '');
	}
	else {
		thisMonth = thisMonth + parseInt(thisMonthMath);
	}
	if (thisDayIsStatic) {
		thisDay = thisDayMath.replace('s:', '');
	}
	else {
		thisDay = thisDay + parseInt(thisDayMath);
	}
	if (thisYearIsStatic) {
		thisYear = thisYearMath.replace('s:', '');
	}
	else {
		thisYear = thisYear + parseInt(thisYearMath);
	}
	var daysInMonth;
	if (thisDay < 1 && !thisDayIsStatic) {
		if (thisMonthIsStatic) {
			thisDay = 1;
			daysInMonth = GetDaysInMonth(thisMonth, thisYear);
		}
		else {
			thisMonth = thisMonth - 1;
			daysInMonth = GetDaysInMonth(thisMonth, thisYear);
			thisDay = daysInMonth + thisDay;
		}
	}
	else {
		daysInMonth = GetDaysInMonth(thisMonth, thisYear);
	}
	if (thisDay > daysInMonth) {
		if (thisMonthIsStatic) {
			thisMonth = thisMonth + 1;
			daysInMonth = GetDaysInMonth(thisMonth, thisYear)
			thisDay = thisDay - daysInMonth;
		}
		else {
			thisDay = daysInMonth;
		}
	}
	if (thisMonth < 1 && !thisMonthIsStatic) {
		thisMonth = thisMonth + 12;
		if (!thisYearIsStatic) {
			thisYear = thisYear - 1;
		}
	}
	else if (thisMonth > 12 && !thisMonthIsStatic) {
		thisMonth = thisMonth - 12;
		if (!thisYearIsStatic) {
			thisYear = thisYear + 1;
		}
	}

	return thisMonth + '/' + thisDay + '/' + thisYear;
}

function InitUI(whichReport) {
	jQuery('#dfrom').val('');
	jQuery('#dto').val('');
	jQuery('#dto').attr('disabled', 'disabled');
	jQuery('#dfrom').attr('disabled', 'disabled');
	jQuery('.extraParams').remove();
	jQuery('#dfrom').css('background-color', '');
	jQuery('#dto').css('background-color', '');
	if (whichReport == '') {
		jQuery('#rcontent').html('<h3>Please to select a Report to view from the Toolbar above.</h3>');
		fixfooter(null, null);
		return;
	}

	else if (whichReport == 'PANTERAMARKETING') {
		jQuery('#rcontent').html("<img style='width:100%;' src='/portals/_default/customReports.png'/>");
		jQuery('#refresh').hide();
		jQuery('#expacro').hide();
		jQuery('#expexc').hide();
		return;
	}
	jQuery('#refresh').show();
	jQuery('#expacro').show();
	jQuery('#expexc').show();
	var dnow = new Date();
	var dateFrom = new Date();
	dateFrom.setDate(dnow.getDate() - 30);
	var dateTo = new Date();
	dateTo.setDate(dnow.getDate() + 1);
	switch (whichReport) {
		case 'TOOLHITD':
		case 'TOOLHITR':
		case 'TOOLBARR':
		case 'TOOLBARD':
			dnow = new Date();
			dateFrom = new Date('1/1/' + dnow.getFullYear().toString());
			dateTo = new Date('12/31/' + dnow.getFullYear().toString());
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case "FUNKPEND":
		case "FUNKUPCO":
		case "FUNKWOLO":
			dnow = new Date();
			dateFrom = new Date('1/1/' + dnow.getFullYear().toString());
			dateTo = new Date('12/31/' + dnow.getFullYear().toString());
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case 'LVBidRecList':
			dnow = new Date();
			dateFrom = new Date();
			dateFrom.setDate(dnow.getDate());
			dateTo = new Date();
			dateTo.setDate(dnow.getDate());
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case 'FTPAccessKeys':
		case 'FTPOrders':
			dnow = new Date();
			dateFrom = new Date();
			dateFrom.setDate(dnow.getDate() - 1);
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case 'ABAdded':
		case 'FTPAuditLog':
		case 'DownloadActivity':
		case 'LVPList':
		case 'FLProjectList':
		case 'PortalRegistration':
		case 'InactivePart':
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;

		case 'LVBidList':
		case 'LVBidCal':
		case 'LVPLSentBy':
		case 'LVPLFollowup':
		case 'LVProjectStatus':
		case 'LVCallerInitials':
		case 'LVAWARDSUMEST':
		case 'LVAWARDSUMSTORE':
			dnow = new Date();
			dateFrom = new Date();
			dateTo = new Date();
			dateTo.setDate(dnow.getDate() + 90);
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case 'LVOpenBidList':
			dnow = new Date();
			dateFrom = new Date(2014, 5, 1);
			dateTo = new Date();
			dateTo.setDate(dnow.getDate() - 1);
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case 'QUASPLBD':
		case 'FULCPLBD':
			dnow = new Date();
			dateFrom = new Date();
			dateTo = new Date();
			dateTo.setDate(dnow.getDate() + 30);
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#rcontent').html('<h3>Please select your date range and click Refresh in the Report Viewer Toolbar.</h3>');
			break;
		case 'GCStats':
		case 'GCStatsPM':
		case 'SubStats':
		case 'ABExport':
		case 'ABExportG':
		case 'STENPLREQ':
		case 'STENPLQUO':
		case 'STENPLOPP':
		case 'STENBLGIRLS':
		case 'STENBLSBS':
		case 'STENBLEXC':
		case 'STENBLGC':
		case 'STENBLGS':
		case 'TOOLCACT':
		case 'STENAWARD':
			jQuery('#dfrom').val('');
			jQuery('#dto').val('');
			jQuery('#dfrom').attr('disabled', 'disabled');
			jQuery('#dto').attr('disabled', 'disabled');
			ShowReportLoading();
			break;
		case 'STENBPEST':
			jQuery('#dfrom').removeAttr('disabled');
			jQuery('#dto').removeAttr('disabled');
			jQuery('#dfrom').val('');
			jQuery('#dto').val('');
			break;

		case 'LVPENDBID':
		case 'LVAWARDBID':
		case 'LVAJNOTES':
			dnow = new Date();
			dateTo = new Date();
			if (whichReport == 'LVPENDBID') {
				dateFrom = new Date(2014, 5, 1);
				dateTo.setDate(dnow.getDate() - 1);
			}
			else {
				dateFrom = new Date();
				dateTo.setDate(dnow.getDate() + 90);
			}
			jQuery('#dfrom').val(jQuery.datepicker.formatDate('mm/dd/yy', dateFrom));
			jQuery('#dto').val(jQuery.datepicker.formatDate('mm/dd/yy', dateTo));
			if (whichReport == 'LVAJNOTES') {
				jQuery('#dfrom').attr('disabled', 'true');
				jQuery('#dto').attr('disabled', 'true');
				jQuery('#dfrom').val('');
				jQuery('#dto').val('');
			}
			else {
				jQuery('#dfrom').removeAttr('disabled');
				jQuery('#dto').removeAttr('disabled');
			}
			var pmInput = 'PM: <select id="spm" name="spm" class="ddl" style="width: 140px;"><option value="AP,DM,GC,JH,MB,MD,MK,MS,RF">ALL</option><option value="AP">AP</option><option value="DM">DM</option><option value="GC">GC</option><option value="JH">JH</option><option value="MB">MB</option><option value="MD">MD</option><option value="MK">MK</option><option value="MS">MS</option><option value="RF">RF</option></select>';
			DomInsertParamInput('PM', pmInput);
			ShowReportLoading();
			break;
	}
	if (jQuery('#sReport').val() == 'LVAJNOTES') {
		jQuery('#spm').val('MS');
	}
	else {
		jQuery('#spm').val('jQuery("#spm option:first-child").val()');
	}
	fixfooter(null, null);

	if (!requiresExtraParams(whichReport)) {
		BuildReport(whichReport);
	}
	else {
		BuildReportExtraParams(whichReport);
	}
}

function GetDaysInMonth(m, y) {
	return /8|3|5|10/.test(--m) ? 30 : m == 1 ? (!(y % 4) && y % 100) || !(y % 400) ? 29 : 28 : 31;
}

function fixfooter() {
}